import { useAiAssistantTranscriptionContext } from '../shared/AiAssistantTranscription.context';
import { useAiAssistantVisitSummaryContext } from '../shared/AiAssistantVisitSummary.context';

type VisitTranscriptSummarizeActionRenderProps = {
   summarizeTranscript: VoidFunction;
};

type VisitTranscriptSummarizeActionProps = {
   children: (renderProps: VisitTranscriptSummarizeActionRenderProps) => JSX.Element;
};

export const VisitTranscriptSummarizeAction = (props: VisitTranscriptSummarizeActionProps): JSX.Element => {
   const { summarizeTranscript } = useAiAssistantVisitSummaryContext();

   return props.children({ summarizeTranscript: summarizeTranscript });
};

type TranscriptDiscardActionRenderProps = {
   discardTranscript: VoidFunction;
};

type TranscriptDiscardActionProps = {
   children: (renderProps: TranscriptDiscardActionRenderProps) => JSX.Element;
};

export const TranscriptDiscardAction = (props: TranscriptDiscardActionProps): JSX.Element => {
   const { clearTranscript } = useAiAssistantTranscriptionContext();

   return props.children({ discardTranscript: clearTranscript });
};
